// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1tPMY","paymentContainer":"PaymentPage_paymentContainer__3AxaF"};